import React from 'react';
import { tierBackgroundStyle, tierParentOpacityStyle, tierParentStyle } from '../../style.vs.css';
import type { LoyaltyTierIconProps } from '../..';

export const PlatinumSM = ({ behavior }: Pick<LoyaltyTierIconProps, 'behavior'>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className={behavior === 'changeOpacityOnHover' ? tierParentOpacityStyle : tierParentStyle}
    >
        <path
            d="M7.18182 0.472378C7.68811 0.180069 8.31189 0.180069 8.81818 0.472377L14.11 3.52762C14.6163 3.81993 14.9282 4.36014 14.9282 4.94476V11.0552C14.9282 11.6399 14.6163 12.1801 14.11 12.4724L8.81818 15.5276C8.31189 15.8199 7.68811 15.8199 7.18182 15.5276L1.88998 12.4724C1.38369 12.1801 1.0718 11.6399 1.0718 11.0552V4.94476C1.0718 4.36014 1.38369 3.81993 1.88998 3.52762L7.18182 0.472378Z"
            fill="url(#paint0_linear_1934_151739)"
        />
        <path
            d="M7.18182 0.472378C7.68811 0.180069 8.31189 0.180069 8.81818 0.472377L14.11 3.52762C14.6163 3.81993 14.9282 4.36014 14.9282 4.94476V11.0552C14.9282 11.6399 14.6163 12.1801 14.11 12.4724L8.81818 15.5276C8.31189 15.8199 7.68811 15.8199 7.18182 15.5276L1.88998 12.4724C1.38369 12.1801 1.0718 11.6399 1.0718 11.0552V4.94476C1.0718 4.36014 1.38369 3.81993 1.88998 3.52762L7.18182 0.472378Z"
            fill="url(#paint1_linear_1934_151739)"
            {...(behavior === 'showColorOnHover' ? { className: tierBackgroundStyle } : {})}
        />
        <defs>
            <linearGradient id="paint0_linear_1934_151739" x1="8" y1="0" x2="8" y2="16" gradientUnits="userSpaceOnUse">
                <stop stopColor="#4E76AF" />
                <stop offset="1" stopColor="#213149" />
            </linearGradient>
            <linearGradient id="paint1_linear_1934_151739" x1="8" y1="0" x2="8" y2="16" gradientUnits="userSpaceOnUse">
                <stop stopColor="#6A94D1" />
                <stop offset="1" stopColor="#345A92" />
            </linearGradient>
        </defs>
    </svg>
);
